/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon16Light = forwardRef('ArrowCLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.355 12.851a.5.5 0 0 1-.707.005L5.806 9.063A1.5 1.5 0 0 1 5.8 6.935l3.789-3.789a.5.5 0 1 1 .707.708L6.506 7.642a.5.5 0 0 0 .003.71l3.842 3.792a.5.5 0 0 1 .004.707Z" })));
});
